export default __webpack_public_path__ + "static/media/xsats-logo-tagline-save-and-secure-bitcoin.f7ce107c.png";